import { action, createAsyncAction } from 'typesafe-actions';

import { NpsQuestionnaire } from './type';
import * as actionTypes from './nps.actionTypes';

// Lite — Trigger
export const npsTriggerAsync = createAsyncAction(
  actionTypes.NPS_TRIGGER_REQUEST,
  actionTypes.NPS_TRIGGER_SUCCESS,
  actionTypes.NPS_TRIGGER_FAILURE
)<
  { respondentId: string; organizationID: string; triggerSource: string; startDateTime: string },
  { isEligible: boolean },
  { error: string }
>();

// Lite — Questionnaire
export const npsQuestionnaireAsync = createAsyncAction(
  actionTypes.NPS_QUESTIONNAIRE_REQUEST,
  actionTypes.NPS_QUESTIONNAIRE_SUCCESS,
  actionTypes.NPS_QUESTIONNAIRE_FAILURE
)<{ language: string }, { questionnaire: NpsQuestionnaire }, { error: string }>();

// Lite — Modal control
export const npsOpenModal = () => action(actionTypes.NPS_OPEN_MODAL);
export const npsCloseModal = () => action(actionTypes.NPS_CLOSE_MODAL);

// Lite — Submit
export type NpsSubmitPayload = {
  npsReportId: string;
  submittedDate: string;
  respondentId: string;
  respondentEmail: string;
  respondentRole: string;
  organizationID: string;
  originatedFrom: string;
  gtmTracking: string;
  deviceDetails: {
    osType: string;
    osVersion: string;
    deviceId: string;
    browserType: string;
    ipAddress: string;
    softwareVersion: string;
  };
  questionnaireId: string;
  responseDetails: Array<{ questionId: string; questionText: string; answer: string[] }>;
  startDate: string;
  actionType: 'submitted';
};

export const npsSubmitAsync = createAsyncAction(
  actionTypes.NPS_SUBMIT_REQUEST,
  actionTypes.NPS_SUBMIT_SUCCESS,
  actionTypes.NPS_SUBMIT_FAILURE
)<NpsSubmitPayload, undefined, { error: string }>();

// Lite — Dismiss
export type NpsDismissPayload = {
  respondentId: string;
  organizationID: string;
  actionType: 'dismissed';
  deviceDetails: NpsSubmitPayload['deviceDetails'];
};

export const npsDismissAsync = createAsyncAction(
  actionTypes.NPS_DISMISS_REQUEST,
  actionTypes.NPS_DISMISS_SUCCESS,
  actionTypes.NPS_DISMISS_FAILURE
)<NpsDismissPayload, undefined, { error: string }>();

// Lite — Session
export const npsResetSession = () => action(actionTypes.NPS_RESET_SESSION);
export const npsSetTriggerSource = (source: string) => action(actionTypes.NPS_SET_TRIGGER_SOURCE, { source });
export const npsSetStartDateTime = (dateTime: string) => action(actionTypes.NPS_SET_START_DATETIME, { dateTime });
